import { types, actions } from './requests'
export const GETLASTBABYPRESSADATA_TYPES = {
    ...types('GETLASTBABYPRESSADATA'),
}
export const GETLASTBABYPRESSADATA_ACTIONS = {
    ...actions('GETLASTBABYPRESSADATA'),
}
